export const COOKIE_CONSENT_NAME = "gs_cookie_consent";
export const COOKIE_CONSENT_MAX_AGE = 60 * 60 * 24 * 180;
export const COOKIE_CONSENT_EVENT = "gs:cookie-consent";

export type CookieConsentChoice = "necessary" | "all";

const OPTIONAL_COOKIE_PREFIXES = [
  "_ga",
  "_gid",
  "_gat",
  "_gcl_",
  "_fbp",
  "_ts",
  "ts_",
];

export function readCookieConsent(): CookieConsentChoice | null {
  if (typeof document === "undefined") {
    return null;
  }

  const value = document.cookie
    .split(";")
    .map((part) => part.trim())
    .find((part) => part.startsWith(`${COOKIE_CONSENT_NAME}=`))
    ?.split("=")[1];

  return value === "necessary" || value === "all" ? value : null;
}

export function persistCookieConsent(choice: CookieConsentChoice) {
  const secure = window.location.protocol === "https:" ? "; Secure" : "";
  document.cookie = `${COOKIE_CONSENT_NAME}=${choice}; Path=/; Max-Age=${COOKIE_CONSENT_MAX_AGE}; SameSite=Lax${secure}`;
}

export function clearOptionalCookies() {
  if (typeof document === "undefined") {
    return;
  }

  const names = document.cookie
    .split(";")
    .map((part) => part.trim().split("=")[0])
    .filter((name) =>
      OPTIONAL_COOKIE_PREFIXES.some((prefix) => name.startsWith(prefix)),
    );

  const hostnameParts = window.location.hostname.split(".");
  const parentDomain =
    hostnameParts.length > 1
      ? `.${hostnameParts.slice(-2).join(".")}`
      : undefined;

  names.forEach((name) => {
    document.cookie = `${name}=; Path=/; Max-Age=0; SameSite=Lax`;
    if (parentDomain) {
      document.cookie = `${name}=; Domain=${parentDomain}; Path=/; Max-Age=0; SameSite=Lax`;
    }
  });
}
